import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';
import EmailField from './EmailField';
import * as Utils from '../../utils/utils';

import { trackingWrapper } from '../../utils/analytics';

class SharePanel extends Component {

	constructor(props){
		super(props);

		this.key = 0;
		this.minEmailFields = 3;
		this.maxEmailFields = 8;

		this.publicID = "";

		this.state = {
			"emailFields": [],
			"emailErrorKeys": [],
			"emailProcessing": false,
			"emailSuccess": false
		}

		//

		this.handleCopyLink = this.handleCopyLink.bind(this);
		this.handleDeleteEmailField = this.handleDeleteEmailField.bind(this);
		this.handleUpdateEmailField = this.handleUpdateEmailField.bind(this);
		this.handleAddEmailField = this.handleAddEmailField.bind(this);
		this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
		this.validEmailFields = this.validEmailFields.bind(this);
		this.handleFacebookShare = this.handleFacebookShare.bind(this);
		this.handleTwitterShare = this.handleTwitterShare.bind(this);

	}

	componentDidMount(){
		console.log("== Share mounted ==");

		if(window.app.configData.useTestPublicID){
			this.publicID = window.app.configData.testPublicID;
		}
		else{
			this.publicID = this.props.publicID;
		}

		console.log("this.publicID", this.publicID);

		this.initFields();
		this.animateIn();
	}

	initFields(){
		console.log("Share initFields");

		let emailFields = [];

		for(let i = 0; i < this.minEmailFields; i++){
			emailFields.push(this.createNewEmailDataObj());
		}

		console.log("emailFields", emailFields);

		this.setState({
			"emailFields": emailFields
		});
	}

	createNewEmailDataObj(){
		let emailObj = {
			"key": this.key++,
			"firstName": "",
			"email": ""
		}

		return emailObj;
	}

	animateIn(){
		window.TweenMax.set(this.refs.darkener, {opacity:0});
		window.TweenMax.to(this.refs.darkener, .5, {opacity:1});

		window.TweenMax.set(this.refs.content, {transform:"translate(-50%, -30%)", opacity:0});
		window.TweenMax.to(this.refs.content, .5, {ease:"expo.out", transform:"translate(-50%, -50%)", opacity:1, delay:.2});
	}

	handleCopyLink(){
		//console.log("copy link");
		navigator.clipboard.writeText(this.refs.link.value).then(function() {
			//console.log('Async: Copying to clipboard was successful!');
		}, function(err) {
			//console.error('Async: Could not copy text: ', err);
		});

		// tracking
		trackingWrapper('event', 'ASDIY-share-copy', {'event_category':'america-says-diy'});
	}

	getIndexOfKey(key){
		for(let i = 0; i < this.state.emailFields.length; i++){
			if(this.state.emailFields[i].key === key){
				return i;
			}
		}

		return -1;
	}

	handleDeleteEmailField(key){
		const index = this.getIndexOfKey(key);
			
		let newEmails = [...this.state.emailFields];

		newEmails.splice(index, 1);

		this.setState({
			"emailFields": newEmails
		});		
	}

	handleUpdateEmailField(key, emailFieldObj){
		let newEmails = [...this.state.emailFields];
		let index = this.getIndexOfKey(key);

		newEmails[index] = emailFieldObj;

		this.setState({
			"emailFields": newEmails
		});
	}

	handleAddEmailField(){
		let newEmailFields = [...this.state.emailFields];

		newEmailFields.push(this.createNewEmailDataObj());

		this.setState({
			"emailFields": newEmailFields
		});
	}

	handleEmailSubmit(){
		//console.log("Share - handleEmailSubmit");

		//console.log("this.state.emailFields", this.state.emailFields);

		if(this.validEmailFields()){
			console.log("!!!! email form is valid");

			if(window.app.configData.useAPI_emailShare){

				this.setState({
					"emailProcessing": true
				});


				const apiSource = window.app.configData.APIsource;
				const emailShareAPI = window.app.configData[apiSource].emailShare,
					emailData = this.removeBlankEmailData(),
					emailShareCount = emailData.length;

				let data = JSON.stringify({
					emailData,
					"registeredEmail": this.props.email,
					"id": this.publicID,
					type: 'create'
				});

				console.log("email api data", data);

				fetch(emailShareAPI, {
					method: 'POST',
					body: data,
				})
				.then((response) => response.json())
				.then((data) => {
					console.log('emailShare api Success:', data);
	
					if(data.status === 202){
						this.setState({
							"emailProcessing": false,
							"emailSuccess": true
						});

						//

						// tracking
						trackingWrapper('event', 'ASDIY-share-email-'+emailShareCount, {'event_category':'america-says-diy'});

						//

						this.props.handleEmailSuccess();

					}
					else if(data.status === 400){
						alert("Something went wrong. Please try again later.");
	
						this.setState({
							"emailProcessing": false,
							"emailSuccess": false
						});
					}
				})
				.catch((error) => {
					
					console.error('emailShare api Error:', error);
					alert("Something went wrong. Please try again later.");
	
					this.setState({
						"emailProcessing": false,
						"emailSuccess": false
					});
					
				});
			}
			else{
				this.setState({
					"emailSuccess": true
				});
			}
		}
	}

	validEmailFields(){
		let emailErrorKeys = [];
		let emailList = this.removeBlankEmailData();

		if(emailList.length === 0){
			alert("Please enter information for at least one recipient.");
			return false;
		}
		else {
			for(let i = 0; i < emailList.length; i++){
				const isName = (emailList[i].firstName !== "");
				const isEmail = (Utils.isEmail(emailList[i].email));
			
				if(isName === false || isEmail === false ){
					emailErrorKeys.push(
						{
							"key": emailList[i].key,
							"firstName": isName,
							"email": isEmail
						}
					);
				}
			}

			if(emailErrorKeys.length > 0){
				alert("Errors found: Please enter proper names and valid email addresses");

				this.setState({
					"emailErrorKeys": emailErrorKeys
				});

				return false;
			}
			else {
				this.setState({
					"emailErrorKeys": []
				});

				return true;
			}
		}
	}

	removeBlankEmailData(){
		let filteredEmailArray = [];
		let emailFields = this.state.emailFields;

		for(let i = 0; i < emailFields.length; i++){
			let name = emailFields[i].firstName;
			let email = emailFields[i].email;
			
			if(name !== "" || email !== ""){
				filteredEmailArray.push(emailFields[i]);
			}
		}

		//console.log("filteredEmailArray", filteredEmailArray);

		return filteredEmailArray;
	}

	getErrorDataByKey(key){
		for(var i = 0; i < this.state.emailErrorKeys.length; i++){
			if(this.state.emailErrorKeys[i].key === key){
				return this.state.emailErrorKeys[i];
			}
		}

		return false;
	}

	handleFacebookShare(){
		const shareMsg = window.app.configData.socialShareMsg;
		const shareURL = this.props.shareURL;
		Utils.facebookSharer(shareURL);

		// tracking
		trackingWrapper('event', 'ASDIY-share-facebook', {'event_category':'america-says-diy'});
	}

	handleTwitterShare(){
		const shareMsg = window.app.configData.socialShareMsg;
		const shareURL = this.props.shareURL;
		Utils.twitterShare(shareMsg, shareURL);

		// tracking
		trackingWrapper('event', 'ASDIY-share-twitter', {'event_category':'america-says-diy'});
	}

	renderEmailFields(){
		//console.log("Share renderEmailFields");
		
		return(
			<React.Fragment>
				{this.state.emailFields.map((emailObj) => {
					let showDelete = true;

					if(this.state.emailFields.length <=3){
						showDelete = false;
					}

					return(
						<EmailField key={emailObj.key} emailObj={emailObj} errorObj={this.getErrorDataByKey(emailObj.key)} showDelete={showDelete} handleDeleteEmailField={this.handleDeleteEmailField} handleUpdateEmailField={this.handleUpdateEmailField} />
					)
				})}
			</React.Fragment>
		)
	}

	renderAddEmailBtn(){
		if(this.state.emailFields.length < 8){
			return(
				<div className="addContact" onClick={this.handleAddEmailField}>Add More Email Addresses</div>
			)
		}
	}

	renderEmailSubmitBtn(){
		let processing = "";

		if(this.state.emailProcessing){
			processing = "processing";
		}

		//

		let statusMsg = "Send Email to Friends";

		if(this.state.emailSuccess){
			statusMsg = "Emails sent!";
		}

		return(
			<div className={"sendEmailBtn " + processing} onClick={() => this.handleEmailSubmit()}>
				<div className="label">{statusMsg}</div>
				<div className="spinner fas fa-spinner fa-pulse"></div>
			</div>
		);
	}

	render() {

		let emailSuccessClass = "";

		if(this.state.emailSuccess){
			emailSuccessClass = "disabled";
		}

		return (
			<div id="sharePanel">
				<div className="darkener" ref="darkener"></div>
				<div className="content_wrapper" ref="content">
					<div className="heading">
						<div className="text">Share your game with your Friends & Family!</div>
						<div className="closeBtn fa-sharp fa-solid fa-xmark" onClick={this.props.handleShareClose}></div>
					</div>
					<div className="share_wrapper">
						<div className={"email_wrapper " + emailSuccessClass}>
							<div className="label">SHARE BY EMAIL</div>
							{this.renderEmailFields()}
							<div className="lineItem">
								{this.renderAddEmailBtn()}
								{this.renderEmailSubmitBtn()}
							</div>
						</div>

						<div className="verticalDivider"></div>

						<div className="right_wrapper">
							<div className="social_wrapper">
								<div className="label">SHARE BY SOCIAL</div>
								<div className="socialIcon fa-brands fa-square-facebook" onClick={this.handleFacebookShare}></div>
								<div className="socialIcon fa-brands fa-square-twitter" onClick={this.handleTwitterShare}></div>
							</div>

							<div className="horizontalDivider"></div>

							<div className="link_wrapper">
								<div className="label">SHARE BY LINK</div>
								<div className="lineItem">
									<input className="linkField" type="text" ref="link" value={this.props.shareURL} readOnly /><div className="copyBtn" onClick={this.handleCopyLink}>COPY</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SharePanel;


// WEBPACK FOOTER //
// ./src/js/components/generator/SharePanel.js